module.exports = __webpack_public_path__ + "img/other_phone.b222dd84.png";